import axios from '@/libs/api.request'

// 获取客户列表
export const getCustomerList = (data) => {
  return axios.request({
    url: 'cus/list',
    data: data,
    method: 'post',
  })
}

// 获取用户详情
export const getCustomerDetail = (id) => {
  return axios.request({
    url: `cus/${id}`,
    method: 'get',
  })
}

// 获取用户订单历史
export const getCustomerOrders = (data) => {
  return axios.request({
    url: 'cus/orders',
    data: data,
    method: 'post',
  })
}

// 获取用户消费统计
export const getCustomerStats = (id) => {
  return axios.request({
    url: `cus/${id}/stats`,
    method: 'get',
  })
}

// 更新用户状态
export const updateCustomerStatus = (data) => {
  return axios.request({
    url: 'cus/status',
    data: data,
    method: 'post',
  })
}

// 批量操作用户
export const batchUpdateCustomers = (data) => {
  return axios.request({
    url: 'cus/batch-update',
    data: data,
    method: 'post',
  })
}

// 导出用户数据
export const exportCustomers = (data) => {
  return axios.request({
    url: 'cus/export',
    data: data,
    method: 'post',
    responseType: 'blob',
  })
}

// 获取用户标签列表
export const getCustomerTags = () => {
  return axios.request({
    url: 'cus/tags',
    method: 'get',
  })
}

// 更新用户标签
export const updateCustomerTags = (data) => {
  return axios.request({
    url: 'cus/tags',
    data: data,
    method: 'post',
  })
}